import React, { useState } from 'react';
import { Box, TextField, Button, Alert, Typography, Paper } from '@mui/material';
import { login } from '../api';
import logo from '../logo.svg'; // Placeholder for your logo

export default function LoginPage({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await login(username, password);
      localStorage.setItem('access_token', res.data.access);
      localStorage.setItem('refresh_token', res.data.refresh);
      if (onLogin) onLogin();
      // Redirect to dashboard/landing page after login
      window.location.href = '/';
    } catch (err) {
      setError('Invalid username or password');
    }
    setLoading(false);
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', bgcolor: 'background.default' }}>
      <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Paper elevation={3} sx={{ p: { xs: 3, sm: 4 }, width: '100%', maxWidth: 360, textAlign: 'center' }}>
          <Box sx={{ mb: 2 }}>
            <img src={logo} alt="Logo" style={{ height: 48, marginBottom: 8 }} />
          </Box>
          <Typography variant="h5" fontWeight={700} color="primary.main" mb={2}>
            Sign In
          </Typography>
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          <Box component="form" onSubmit={handleSubmit}>
            <TextField
              label="Username"
              value={username}
              onChange={e => setUsername(e.target.value)}
              fullWidth
              margin="normal"
              required
              autoFocus
            />
            <TextField
              label="Password"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              fullWidth
              margin="normal"
              required
            />
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              sx={{ mt: 2, fontWeight: 600 }}
              disabled={loading}
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </Button>
          </Box>
        </Paper>
      </Box>
      <Box sx={{ textAlign: 'center', py: 2, color: 'text.secondary', fontSize: 13 }}>
        POS is a Shrek53 product © {new Date().getFullYear()}
      </Box>
    </Box>
  );
}
